<template>
  <div >
    <Header />
    <div class="main margin-body" >
        <!-- Aqui van las vistas cargadas -->
        <router-view></router-view>
    </div>
    <!--footer-->
      <Footer />
  </div>
</template>

<script>
import Header from "@/containers/layout/Header.vue";
import Footer from "@/containers/layout/Footer.vue";

export default {
  name: "Dashboard",
  components: {
    Footer,
    Header
  },
  data() {
    return {};
  }
};
</script>